import React, { useState } from "react";
import { LoginUser, resetPassword } from "~/assets/js/Api/userApi";
import {
    ForgotPasswordForm,
    LoginForm,
    RegisterForm,
} from "~/assets/js/components/Forms/modules";
import CustomerNotification from "../../components/CustomerNotification";
import { DesktopGrid } from "~/assets/js/components/Layout/DesktopGrid";

const PATHS = {
    LOGIN: "login",
    REGISTER: "register",
};

const Login = () => {
    const [forgotPasswordView, setForgotPassword] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [notification, setNotification] = useState({
        show: false,
        variant: "success",
        path: null,
    });

    const hardRefreshPage = () => (window.location = "/mein-konto/");

    const handleLogin = async ({ email, password, staySigned }) => {
        setLoading(true);
        const response = await LoginUser(email, password, staySigned);

        if (response.ok && response.user) {
            return hardRefreshPage();
        }

        setLoading(false);
        return setNotification({
            show: true,
            variant: "danger",
            path: PATHS.LOGIN,
        });
    };

    const handleForgotPassword = async ({ email }) => {
        setLoading(true);
        const response = await resetPassword(email);
        setLoading(false);
        if (response.ok) {
            return setForgotPassword(false);
        }
    };

    const handleRegisterResponse = async (response) => {
        if (!response.ok) {
            return setNotification({
                show: true,
                variant: "danger",
                path: PATHS.REGISTER,
            });
        }

        hardRefreshPage();
    };

    if (forgotPasswordView) {
        return (
            <ForgotPasswordForm
                onSubmit={handleForgotPassword}
                isLoading={isLoading}
                changeView={() => setForgotPassword(false)}
            />
        );
    }

    return (
        <>
            <DesktopGrid
                leftSide={
                    <>
                        <CustomerNotification
                            show={
                                notification.show &&
                                notification.path === PATHS.LOGIN
                            }
                            path={PATHS.LOGIN}
                            variant={notification.variant}
                        />
                        <LoginForm
                            onSubmit={handleLogin}
                            isLoading={isLoading}
                            changeView={() => setForgotPassword(true)}
                        />
                    </>
                }
                rightSide={
                    <>
                        <CustomerNotification
                            show={
                                notification.show &&
                                notification.path === PATHS.REGISTER
                            }
                            path={PATHS.REGISTER}
                            variant={notification.variant}
                        />
                        <RegisterForm
                            onSubmitResponse={handleRegisterResponse}
                        />
                    </>
                }
            />
        </>
    );
};

export default Login;
